import { component } from 'picoapp';
import { gsap } from 'gsap';

export default component((node, ctx) => {
  const toggleButtons = node.querySelectorAll('.js-dropdown-toggle');
  const icon = node.querySelector('.js-dropdown-icon');
  const list = node.querySelector('.js-dropdown-list');
  const selected = node.querySelector('.js-dropdown-selected') || false;
  const closeOnSelect = node.dataset.closeOnSelect || true;

  const isMobile = ctx.getState().isMobile;
  let isOpen = false;
  let isDrawer = false;

  const open = () => {
    isOpen = true;
    if (isDrawer) {
      gsap.to(list, { x: '0%', duration: 0.4, ease: 'power3.inOut' });
      document.body.classList.add('no-scroll');
    } else {
      gsap.set(node, { zIndex: 10000 });
      gsap.to(list, { autoAlpha: 1, duration: 0.2 });
      gsap.to(list, { height: 'auto', duration: 0.2 });
      gsap.to(icon, { scaleY: -1, duration: 0.1 }, 0);
    }
    window.addEventListener('click', handleClickOutside);
  };

  const handleClickOutside = (e) => {
    if (!e.composedPath().includes(node)) {
      close();
    }
  };

  const handleSelection = (e) => {
    const input = e.target;
    const label = node.querySelector(`label[for="${input.id}"]`);
    if (selected) selected.innerText = label.innerText;
    if (closeOnSelect == true) close();
  };

  const close = () => {
    isOpen = false;
    if (isDrawer) {
      gsap.to(list, { x: '100%', duration: 0.4, ease: 'power3.inOut' });
      document.body.classList.remove('no-scroll');
    } else {
      gsap.to(icon, { scaleY: 1, duration: 0.1 }, 0);
      gsap.to(list, { height: 0, duration: 0.2 });
      gsap.to(list, { autoAlpha: 0, duration: 0.2 });
      gsap.set(node, { zIndex: 2, delay: 0.4, });
    }
    window.removeEventListener('click', handleClickOutside);
  };

  const toggle = () => isOpen ? close() : open();

  const closeButton = node.querySelector('.js-dropdown-close');
  if (closeButton) closeButton.addEventListener('click', close);

  const addEventListeners = () => {
    toggleButtons.forEach((button) => {
      button.addEventListener('click', toggle);
    });
    list.addEventListener('change', handleSelection);
  };

  const removeEventListeners = () => {
    toggleButtons.forEach((button) => {
      button.removeEventListener('click', toggle);
    });
    list.removeEventListener('change', handleSelection);
  };

  const init = () => {
    isOpen = false;
    isDrawer = isMobile.matches && node.dataset.mobile == 'drawer';
    addEventListeners();
  };

  const destroy = () => {
    removeEventListeners();
    gsap.set(list, { clearProps: 'all' });
    document.body.classList.remove('no-scroll');
  };

  const refresh = () => {
    destroy();
    init();
  };

  init();
  isMobile.addEventListener('change', refresh);
  // Creates a conflict in dropdown when the product appears twice in the same page
  // ctx.on('recommendations:updated', refresh);
});